<template>
    <!-- 会话列表 -->
    <div class="max_box">
        <!-- top -->
        <div class="top_box">
          <span class="top_span"><span @click="cancel()" style="cursor: pointer;">质检明细报表</span>> 会话列表</span>
<!--          <span class="top_span">会话列表</span>-->
        </div>
      <!-- form -->
      <div class="form_box">
        <el-select size="small" clearable placeholder="所有会话" style="width: 180px;margin-right: 10px">
          <el-option></el-option>
        </el-select>
        <el-input
          size="small"
          class="selectInput"
          style="width:180px"
          placeholder="请您输入搜索座席"
        >
          <svg slot="suffix" class="icon" aria-hidden="true">
            <use xlink:href="#iconsearchicon" />
          </svg>
        </el-input>
      </div>
      <!-- table -->
      <el-table class="table_box_el_table" :data="tableData" ref="el_table" size="size">
        <el-table-column label="序号" align="center" type="index" width="50px"></el-table-column>
        <el-table-column label="会话ID" align="center"></el-table-column>
        <el-table-column label="坐席" align="center"></el-table-column>
        <el-table-column label="质检员" align="center"></el-table-column>
        <el-table-column label="智能质检扣分" align="center" width="70"></el-table-column>
        <el-table-column label="智能质检加分" align="center" width="70"></el-table-column>
        <el-table-column label="智能质检总分" align="center" width="70"></el-table-column>
        <el-table-column label="人工抽检总分" align="center" width="70"></el-table-column>
        <el-table-column label="派单日期" align="center"></el-table-column>
        <el-table-column label="通话开始时间" align="center"></el-table-column>
        <el-table-column label="通话结束时间" align="center"></el-table-column>
        <el-table-column label="通话时长" align="center"></el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="120px">
          <template>
            <div class="table_button_box">
              <el-tooltip class="item" effect="light" content="查看" placement="bottom">
                <el-button
                  @click="showMore"
                  type="text"
                >
                  <svg class="icon icon-bianji" aria-hidden="true">
                    <use xlink:href="#iconxiangqing" />
                  </svg>
                </el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- page -->
      <!--            <Page v-bind:init_item="pageBuild" @currentPage="currentPage"/>-->
      <!-- drawer -->
      <el-drawer title=""
                 :before-close="cancelForm"
                 :visible.sync="dialog"
                 custom-class="demo-drawer"
                 class="drawer-custom"
                 size="560px">
        <div class="header-border-l">会话详情</div>
        <div class="bfb mdialog_box"
             style="max-height: 450px;min-height: 400px;">
          <div v-for="obj in chatLogList"
               :key="obj.id">
            <!-- 用户消息start -->
            <div name="messageList"
                 v-if="obj.direction=='up'"
                 :class="obj.defaultClass"
                 :id="'row'+obj.cid">
              <div class="bfb left mdialog_datatxt">
                <span style="font-size:14px;padding-right:10px;color:#000;">{{obj.username}}</span>
                <span style="font-size:12px;">{{obj.createTime}}</span>
              </div>
              <div>
                <div class="mdialog_ico left">
                  <p><span class="iconfont iconmenuicon-kehu"></span></p>
                </div>
                <div class="mdialog_txtbox left">
                  <div class="bfb left">
                    <div v-if="obj.type=='text'"
                         class="mdialog_audio left mdialog_bg2 c444 pst">
                      <div class="mdialog_l"></div>
                      <div class="mdialog_txt left">
                        {{obj.msgContent}}
                      </div>
                    </div>
                   <!-- <div v-if="obj.type=='file'"
                         class="mdialog_audio left mdialog_bg2_file c444 pst"
                         style="background-color:#e4e4e4;">
                      <div class="mdialog_l"></div>
                      <div v-if="obj.msgContent.url.includes('/res/videos/')"
                           class="mdialog_txt left">
                        <div class="input_video">
                          <video-player class="video-player vjs-custom-skin"
                                        ref="videoPlayer"
                                        :playsinline="true"
                                        :options="obj.playerOptions"></video-player>
                        </div>
                      </div>
                      <div v-else
                           class="mdialog_txt left">
                        <el-link type="primary"
                                 :href="obj.msgContent.url">{{obj.msgContent.name}} <i class="el-icon-download"></i></el-link>
                      </div>
                    </div>-->
                    <div v-if="obj.type=='image'"
                         class="mdialog_txt left">
                      <el-image :src="obj.msgContent.url"
                                style="width:200px;height:160px;"></el-image>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 用户消息end -->
            <!-- 客服消息start -->
            <div name="messageList"
                 v-if="obj.direction=='down'"
                 :class="obj.defaultClass"
                 :id="'row'+obj.cid">
              <div class="bfb right tr mdialog_datatxt">
                <span style="font-size:12px;padding-left:10px;">{{obj.createTime}}</span>
                <span style="font-size:14px;color:#000;"> {{obj.user}}</span>
              </div>
              <div class="mdialog_ico right">
                <p><span class="iconfont iconheadicon-zuoxi"></span></p>
              </div>
              <div class="mdialog_txtbox right">
                <div class="bfb right">
                  <div v-if="obj.type=='text'"
                       class="mdialog_audio right mdialog_bg1 cfff pst">
                    <div class="mdialog_r"></div>
                    <div class="mdialog_txt right">
                      {{obj.msgContent}}
                    </div>
                  </div>
                  <!--<div v-if="obj.type=='file'"
                       class="mdialog_audio right mdialog_bg1_file cfff pst"
                       style="background-color:white;">
                    <div class="mdialog_r"></div>
                    <div v-if="obj.msgContent.url.includes('/res/videos/')"
                         class="mdialog_txt right">
                      <div class="input_video">
                        <video-player class="video-player vjs-custom-skin"
                                      ref="videoPlayer"
                                      :playsinline="true"
                                      :options="obj.playerOptions"></video-player>
                      </div>
                    </div>
                    <div v-else
                         class="mdialog_txt right">
&lt;!&ndash;                      @click="chatLogDownloadFile(obj.msgContent.url,obj.msgContent.name)"&ndash;&gt;
                      <el-link type="primary"
                               icon="el-icon-download">{{obj.msgContent.name}}</el-link>
                    </div>
                  </div>-->
                  <div v-if="obj.type=='image'"
                       class="mdialog_image right">
                    <el-image :src="obj.msgContent.url"
                              style="width:200px;height:160px;"></el-image>
                  </div>
                </div>
              </div>
            </div>
            <!-- 客服消息end -->
          </div>
        </div>
        <div class="header-border-l" style="margin-top: 15px">质检结果</div>
        <el-table size="small" max-height="360" width="100%" :data="tableData1"
                  style="margin-top:10px;margin-bottom:10px;">
          <el-table-column type="index" align="center" prop="a" label="序号" width="50">11</el-table-column>
          <el-table-column type="index" align="center" prop="b" label="类别"></el-table-column>
          <el-table-column type="index" align="center" prop="c" label="质检项名称" width="110"></el-table-column>
          <el-table-column type="index" align="center" prop="d" label="类型"></el-table-column>
          <el-table-column type="index" align="center" prop="e" label="分值"></el-table-column>
          <el-table-column type="index" align="center" prop="f" label="智能质检得分" width="70"></el-table-column>
          <el-table-column type="index" align="center" label="人工抽检总分" width="70"></el-table-column>
          <el-table-column type="index" align="center" label="复核得分" width="70"></el-table-column>
        </el-table>
      </el-drawer>
    </div>
</template>

<script>
import Page from '@/views/qc/public/PageComponent'
// import { getChatLogList, getSessionLogList, downloadFile } from '@/api/qc/realTimeReport'
export default {
  name: 'sessionList',
  components: {
    Page
  },
  data: function () {
    return {
      dialog: false,
      tableData: [
        {
          name: 1
        }
      ],
      tableData1: [
        {
          a: 1,
          b: 1,
          c: 1,
          d: 1,
          e: 1,
          f: 1
        }
      ],
      tableData2: [
        {
          aa: 1,
          bb: 1,
          cc: ''
        }
      ],
      chatLogList: [
        {
          username: 'aa',
          createTime: '2012.12.12',
          msgContent: '反向迭代仅仅当对象的大小可预先确定或者对象实现了 __reversed__() 的特殊方法时才能生效。 ',
          type: 'text',
          direction: 'up',
          id: 1,
          cid: 123,
          defaultClass: 'bfb mdialog_div left'
        },
        {
          user: 'lily',
          createTime: '2012.12.12',
          msgContent: '不过可以相应的看下。 ',
          type: 'text',
          direction: 'down',
          id: 1,
          cid: 123,
          defaultClass: 'bfb mdialog_div right'
        },
        {
          username: 'aa',
          createTime: '2012.12.12',
          msgContent: [
            {
              url: '/res/videos/aa',
              name: 'na',
              playerOptions: 'playerOptions'
            }
          ],
          type: 'file',
          direction: 'up',
          id: 1,
          cid: 123,
          defaultClass: 'bfb mdialog_div left'
        },
        {
          user: 'lily',
          createTime: '2012.12.12',
          msgContent: [
            {
              url: '/res/videos/aa',
              name: 'na'
            }
          ],
          type: 'image',
          direction: 'down',
          id: 1,
          cid: 123,
          defaultClass: 'bfb mdialog_div right'
        }
      ],
      form_select: {
        // 模型分组
        group: '',
        // 状态
        status: [],
        // 名称
        name: '',
        // 质检类型
        modelType: '',
        // 技能组ID
        skillId: '',
        type: '',
        attrPos: ''
      },
      pageBuild: {
        page_size: 10,
        total: 0,
        currentPage: 1,
        marginBottom: '50px'
      }
    }
  },
  methods: {
    /** 查看 */
    showMore() {
      this.dialog = true
    },
    cancelForm () { // 关闭弹出层
      this.loading = false
      this.dialog = false
    },
    cancel () {
      this.$store.commit('user/setQcDetailPageIndex', { qcDetailPageIndex: 1 })
    }
  },
  /**
   * 页面加载获取页面信息
   */
  mounted() {
    // this.searchModelGroupList(true)
    // 查询技能组
    // this.querySkillGroup()
  }
}
</script>

<style scoped lang="scss">
.header-border-l {
  position: relative;
  margin-top: 5px;
  margin-bottom: 5px;
  color: #333;
  border-bottom: 1px solid #ebebeb;
  padding-left: 20px;
  padding-bottom: 10px;
  font-size: 16px;
  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 4px;
    width: 3px;
    height: 14px;
    background-color: #337eff;
  }
}
.el-drawer__wrapper {
  ::v-deep .el-drawer__container {
    ::v-deep .el-drawer {
      ::v-deep .el-drawer__header {
      }
      ::v-deep .el-drawer__body {
        padding: 10px 20px;
      }
    }
  }
}
</style>
<style scoped>
.el-drawer__wrapper >>> .el-drawer__header{
  border-bottom: #e1e3e6 solid 1px;
  padding: 20px 0 10px 0;
  margin-bottom: 5px;
}
.el-drawer__wrapper >>> .el-drawer__body{
  padding: 10px 20px;
}
.el-drawer__wrapper >>> .el-drawer{
  /*padding: 20px;*/
  overflow: auto;
}
.max_box{
    width: 100%;
}
.top_box{
    width: 100%;
    border-bottom: #e1e3e6 solid 1px;
    padding-top: 12px;
    padding-bottom: 9px;
    margin-bottom: 20px;
}
.top_span{
    color: #222;
    font-size: 20px;
    padding-bottom: 10px;
    border-bottom: #0080fe solid 1px;
    padding-right: 5px;
}
.form_box{
    width: 100%;
}
.table_box_el_table{
    width: 100%;
}
.right{
    float: right;
}
.el-table >>> thead tr th{
    background: #f1f1f1 !important;
    padding: 6px 0 !important;
    color: #444 !important;
}
.el-table >>> tbody tr td {
    padding: 10px 5px;
}
.selectInput {
box-sizing: border-box;
margin-bottom: 10px;
margin-right: 10px;
}
.dialog_top .selectInput >>> .el-input__suffix {
height: 34px;
}
.dialog_top .selectInput >>> .el-input__suffix .el-input__suffix-inner .icon {
margin-top: 9px;
}
.modal-dialogbox {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0;
  bottom: 0;
}
.mdialog_box {
  max-height: 100%;
  overflow-y: auto;
  padding: 15px 0;
}
.mdialog_div {
  margin-bottom: 30px;
}
.mdialog_ico {
  width: 42px;
  height: 42px;
}
.mdialog_ico p {
  width: 36px;
  height: 36px;
  margin: 0 auto;
  background-color: #6ec3ff;
  border-radius: 50%;
  overflow: hidden;
}
.mdialog_txtbox {
  min-width: 80px;
  max-width: 80%;
  width: auto;
  margin-right: 10px;
  margin-left: 10px;
}
.mdialog_datatxt {
  color: #999;
  line-height: 0px;
  padding-bottom: 15px;
  padding-left: 50px;
  padding-right: 50px;
}
.mdialog_audio {
  height: auto;
  line-height: 26px;
  padding: 5px 13px;
  border-radius: 8px;
  text-align: left;
}
.mdialog_txt {
  width: auto;
  border-radius: 2px;
  line-height: 18px;
  padding: 6px 8px;
  font-size: 12px;
  text-align: left;
}
.mdialog_image {
  width: auto;
  height: auto;
}
.mdialog_bg1 {
  background-color: #6ec3ff;
}
.mdialog_bg1_file {
  border: #6ec3ff 1px solid;
}
.mdialog_bg2 {
  background-color: #e4e4e4;
}
.mdialog_bg2_file {
  border: #e4e4e4 1px solid;
}
.mdialog_l {
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-right: 5px solid #e4e4e4;
  position: absolute;
  left: -5px;
  top: 10px;
}
.mdialog_r {
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 5px solid #6ec3ff;
  position: absolute;
  right: -5px;
  top: 10px;
}
.iconfont {
  padding: 6px;
  font-size: 23px !important;
  color: white;
}
.bfb {
  width: 100%;
}
.left {
  float: left;
}
.right {
  float: right;
}
.pst {
  position: relative;
}
.cfff {
  color: #fff;
}
.c444 {
  color: #444;
}
.tr {
  text-align: right;
}
.tl {
  text-align: left;
}
</style>
